import getHelper from '../../../../../services/getHelper';

export default getHelper('/users/:id');
